import { useState } from "react";
import { X, Clock, MapPin, MessageSquare, CalendarX } from "lucide-react";

export default function BookingDetailsModal({ booking, onClose }) {
  const [remarks, setRemarks] = useState("");

  const handleSaveRemarks = () => {
    console.log("Saved remarks for", booking.id, remarks);
    onClose();
  };

  const handleCancelMeeting = () => {
    console.log("Cancelled meeting", booking.id);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white text-sm font-bold flex items-center justify-center">
              {booking.initials}
            </div>
            <div>
              <p className="font-bold text-gray-900">{booking.name}</p>
              <p className="text-sm text-gray-500">{booking.specialty}</p>
            </div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="px-6 py-5">
          <div className="space-y-2 mb-5 text-sm text-gray-700">
            <p className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-gray-400" />
              {booking.date} · {booking.time}
            </p>
            <p className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-gray-400" />
              {booking.location}
            </p>
          </div>

          <label className="block mb-4">
            <span className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 tracking-wide mb-2">
              <MessageSquare className="w-3.5 h-3.5" /> REMARKS
            </span>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Add notes about this meeting..."
              rows={3}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm resize-y focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            />
          </label>

          <button
            type="button"
            onClick={handleCancelMeeting}
            className="flex items-center gap-2 text-sm font-semibold text-red-600 border border-red-200 px-4 py-2 rounded-xl hover:bg-red-50 transition"
          >
            <CalendarX className="w-4 h-4" /> Cancel meeting
          </button>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="text-sm font-semibold text-gray-600 px-4 py-2 hover:text-gray-900 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSaveRemarks}
            className="bg-indigo-600 text-white text-sm font-semibold px-5 py-2.5 rounded-xl hover:bg-indigo-700 transition"
          >
            Save remarks
          </button>
        </div>
      </div>
    </div>
  );
}